// Module
var code = `<!-- §4 THE PLUGINS — RATIFIED-WD (copy of record 2026-08-13; audit fix 2026-08-16: #1 plugin-entry sentence — CLI is not a plugin; Shell is above) -->
<section class="plugins-section" aria-labelledby="plugins-headline">

    <div class="plugins-section__inner">

        <header class="plugins-section__header">
            <h2 id="plugins-headline" class="plugins-section__headline landing-headline"><span class="landing-eyebrow">EXTENSIONS</span>
               Expand your app
            </h2>
            <p class="plugins-section__lead">
                A SpyneJS plugin is a complete SpyneJS application &mdash; the same VBL pattern, plus
                hooks for integration. It connects to the host's single configuration and behaves like everything else in the host.
            </p>
        </header>

        <div class="plugins-section__body">
            <p>
                The web is wider than any framework &mdash; services, libraries, design systems, running
                products. Plugins are how SpyneJS reaches it: external behavior enters through Channels
                and joins the stream; nothing reaches farther than its declared connections.
            </p>
            <p>
                The same shape travels the other way. Components, themes, and working features move
                between applications as plugins &mdash; VBL content any host can register.
            </p>
            <!-- plugin-starter link slot — inert until spynejs/plugin-starter is public -->
            <p>
                Plugins begin by extending SpynePlugin &mdash; one class, one level, the same composition
                rule as everything else. Start from the plugin template, wire a channel, and the
                application can hear it.
            </p>
            <p>
                CMS and the Behavior Console enter this way too &mdash; they ship with the Application
                Shell.
            </p>
        </div>

        <!-- Frank amendment 2026-08-14: suggestion ask cut (too early to solicit plugins) -->
        <p class="plugins-section__candor">
            There's no curated plugin portal yet &mdash; plugins move through GitHub and npm.
        </p>

        <p class="plugins-section__closing">
            The catalog is young. The architecture is not.
        </p>

    </div>

</section>
`;
// Exports
module.exports = code;